import { MapPin, ArrowRight, Phone, CheckCircle2 } from "lucide-react";
import GoogleReviews from "./GoogleReviews";

export default function Hero() {
  return (
    <section
      id="accueil"
      data-testid="hero-section"
      className="anchor-offset pt-16 pb-24 md:pt-20 md:pb-32 bg-[#f8faff] text-[#1a2332] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.4] pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 85% 10%, rgba(0, 168, 107, 0.08), transparent 55%), radial-gradient(circle at 10% 90%, rgba(255, 140, 66, 0.07), transparent 55%)"
      }} />
      <div className="max-w-5xl mx-auto px-6 md:px-8 relative text-center">
        <div className="reveal flex flex-col items-center">
          <span className="inline-flex items-center gap-2 bg-white border border-[#1a2332]/10 rounded-full px-4 py-2 text-xs font-headings font-semibold tracking-wide uppercase text-[#1a2332]/75 shadow-sm">
            <MapPin className="w-3.5 h-3.5 text-[#00a86b]" />
            Boulogne-Billancourt · Île-de-France
          </span>

          <h1 className="font-headings font-black tracking-tight leading-[0.98] mt-6 text-5xl sm:text-6xl lg:text-7xl">
            Auto-école à Boulogne-Billancourt
            <span className="block text-[#00a86b]">votre permis en toute sérénité.</span>
          </h1>

          <GoogleReviews />

          <p className="mt-6 text-lg md:text-xl text-[#1a2332]/70 max-w-2xl leading-relaxed">
            DDSBillancourt (Dynastie Drive School) — votre <strong className="text-[#1a2332]">auto-école</strong> à Boulogne-Billancourt : <strong className="text-[#1a2332]">permis B</strong>, moto, poids lourd, code de la route en ligne et plateforme e-learning. Moniteurs expérimentés et formation accélérée possible.
          </p>

          <div className="mt-12 inline-block" data-testid="hero-price-display">
            <div className="text-xs font-headings font-semibold uppercase tracking-[0.2em] text-[#1a2332]/50">Permis B · à partir de</div>
            <div className="mt-1 flex items-baseline gap-2 justify-center">
              <span className="font-headings font-black text-[#FF8C42] text-7xl sm:text-8xl tracking-tighter">999</span>
              <span className="font-headings font-black text-[#FF8C42] text-4xl sm:text-5xl">€</span>
            </div>
            <div className="mt-2 text-sm text-[#1a2332]/60 font-body">20 leçons + 2 offertes · boîte auto & manuelle · simulateur inclus</div>

            {/* Badge financement mis en avant */}
            <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-testid="hero-financing-badges">
              <span className="inline-flex items-center gap-1.5 bg-[#00a86b] text-white font-headings font-bold rounded-full px-4 py-2 text-sm shadow-md" data-testid="hero-badge-4x">
                💳 Paiement en <span className="text-[#FFE066]">plusieurs fois</span>
              </span>
            </div>
          </div>

          <div className="mt-12 flex flex-wrap gap-4 justify-center">
            <a
              href="#contact"
              data-testid="hero-cta-signup"
              className="bg-[#FF8C42] hover:bg-[#e8763a] text-white font-headings font-bold rounded-xl px-8 py-4 shadow-lg hover:-translate-y-0.5 transition-all text-base inline-flex items-center gap-2"
            >
              S'inscrire <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="tel:+33141315061"
              data-testid="hero-cta-call"
              className="border-2 border-[#1a2332]/15 text-[#1a2332] hover:border-[#00a86b] hover:text-[#00a86b] font-headings font-bold rounded-xl px-8 py-4 transition-colors inline-flex items-center gap-2"
            >
              <Phone className="w-4 h-4" /> 01 41 31 50 61
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-[#5b6577]">
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-[#00a86b]" /> Paiement en plusieurs fois disponible</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-[#00a86b]" /> Réponse rapide</span>
          </div>
        </div>
      </div>
    </section>
  );
}
